<template>
  <BModal
    :modelValue="visible"
    @update:modelValue="$emit('update:visible', $event)"
    dialog-class="modal-md"
    :title="helper.trans('fraudex.leave_feedback')"
    body-class="pt-3"
  >
    <template #default>
      <div v-if="requisite">
        <div class="mb-3">
          <label for="requisiteField" class="form-label">{{ helper.trans('labels.requisites') }}</label>
          <input 
            type="text" 
            class="form-control" 
            id="requisiteField" 
            :value="requisite" 
            readonly
          >
        </div>

        <div class="mb-3">
          <label for="feedbackText" class="form-label">{{ helper.trans('fraudex.comment') }}</label>
          <FormInputWrapper v-slot="parentProps" field="text" form="fraudexFeedback">
            <textarea 
              class="form-control" 
              id="feedbackText" 
              rows="4" 
              v-model="feedbackText"
              :class="parentProps.class"
              :placeholder="helper.trans('fraudex.comment_placeholder')"
            ></textarea>
          </FormInputWrapper>
        </div>
      </div>
    </template>
    <template #footer>
      <button 
        type="button" 
        @click="$emit('update:visible', false)" 
        class="btn btn-outline-secondary btn-sm text-capitalize-first"
      >
        {{ helper.trans('button.cancel') }}
      </button>
      <LoaderWrapper ref="loaderSubmit" :zoom="0.5">
        <button 
          type="button" 
          @click="handleSubmit" 
          :disabled="!feedbackText || feedbackText.trim().length === 0"
          class="btn btn-outline-primary btn-sm text-capitalize-first"
        >
          <i class="fa fa-paper-plane me-2"></i>
          {{ helper.trans('button.send') }}
        </button>
      </LoaderWrapper>
    </template>
  </BModal>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { BModal } from 'bootstrap-vue-3';
import { helper } from '@/service/CommonHelper';
import LoaderWrapper from '@/components/LoaderWrapper.vue';
import FormInputWrapper from '@/components/FormInputWrapper.vue';

export default defineComponent({
  name: 'FraudexFeedbackModal',
  components: {
    BModal,
    LoaderWrapper,
    FormInputWrapper,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    requisite: {
      type: String,
      default: '',
    },
  },
  emits: ['update:visible', 'submit'],
  setup(props, { emit }) {
    const feedbackText = ref('');
    const loaderSubmit = ref<InstanceType<typeof LoaderWrapper> | null>(null);

    watch(() => props.visible, (newVal) => {
      if (newVal) {
        feedbackText.value = '';
        helper.clearErrors('fraudexFeedback');
      }
    });

    const handleSubmit = () => {
      if (!feedbackText.value || feedbackText.value.trim().length === 0) {
        return;
      }
      emit('submit', feedbackText.value);
    };

    return {
      helper,
      feedbackText,
      loaderSubmit,
      handleSubmit,
    };
  },
});
</script>
